module.exports = __webpack_public_path__ + "static/media/celio.0d8205ca.png";